import type { FaireProductEntity } from "../../entity_types/product";

export const p_x9qa7s9ut5: FaireProductEntity = {
  token: "p_x9qa7s9ut5",
  type: "product",
  name: "HOLD THE WINE - Split Toe Chunky Mule",
  brandToken: "b_mz3xxxsvnf",
  brandName: "Lemonade Shoes",
  imageUrl: "https://cdn.faire.com/fastly/cae4b7e68fd1967061c614a4325ce877c0523b649494061ce36abd0649bece2f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/183740fd2161f4aedb5e558aedcddf18e2950e0009c8041e635377dd6b211ae4.jpeg",
    "https://cdn.faire.com/fastly/6a2677f30e80089a8bbe35f53a82241d6497fba31268d990947fbd77fca9610d.jpeg",
    "https://cdn.faire.com/fastly/faec88b2d7fc27a9283405c640cabeadd2d6747c3ac816a8e1a279cd2fdb3c2d.jpeg",
    "https://cdn.faire.com/fastly/7fe30beb64cae3051b9edb4c088bedcc4138f59ae31bd8fe36c45cc97de49788.jpeg"
  ],
  priceDollars: 13.75,
  description: "A modern classic with a twist. This square-toe mule features a subtle split-toe detail and a sleek cross-strap upper for that effortlessly elevated feel. Set on a sturdy mid heel, it’s equal parts minimal and statement—clean lines, soft structure, and just enough edge.\n\nOOTD\nStyle with tailored trousers and a fitted tank for a clean, city look, or pair with a slip dress for something softer and more feminine. Also cute with straight-leg denim and a crisp button-down for that off-duty polish.",
  tags: [],
  msrpDollars: 27.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-13T23:39:12.212Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
